// @flow

import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';

type Props = {
  theme: Object,
  children?: any,
};

const StyledTheme = (props: Props) => (
  <ThemeProvider theme={props.theme}>
    <Fragment>{props.children}</Fragment>
  </ThemeProvider>
);

export default StyledTheme;



// WEBPACK FOOTER //
// ./src/providers/StyledTheme/index.js